import axios from '@/services/apiAxios'



export default {
    namespaced: true,
    state: {
        itemAccount: null,
        itemAccounts: [],
    },
    mutations: {
        setItemAccount(state, payload) {
            state.itemAccount = payload;
        },
        setItemAccounts(state, payload) {
            state.itemAccounts = payload;
        }
    }, 
    actions: {
        storeItemAccount({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url:`${rootState.warehouse.routePrefix}/items/${payload.id}/ledger-settings`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        
        fetchAccountType({ rootState, dispatch }) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/item-ledger-settings`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                } 
                );
            })
        },
        fetchItemAccounts({ rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/items/${payload}/ledger-settings`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        }

    }
}